import Dropdown from 'bootstrap/js/dist/dropdown'
"use strict";
class BootstrapSelect {
    constructor(el, config) {
        var _a, _b;
        this.optionDropdownPairs = [];
        this.defaultTranslations = {
            de: {
                nothingSelected: 'Bitte wählen',
                searchPlaceholder: 'Suchen...',
                noSearchResult: 'Keinen Treffer für diese Suche',
                itemsSelected: '{count} Optionen ausgewählt',
                multipleSelection: 'Mehrfachauswahl möglich',
                closeDropdown: 'Ok'
            },
            en: {
                nothingSelected: 'Please select',
                searchPlaceholder: 'Search...',
                noSearchResult: 'No results for this search',
                itemsSelected: '{count} options selected',
                multipleSelection: 'Multiple selection possible',
                closeDropdown: 'Ok'
            },
            fr: {
                nothingSelected: 'Veuillez sélectionner',
                searchPlaceholder: 'Recherche...',
                noSearchResult: 'Aucun résultat pour cette recherche',
                itemsSelected: '{count} options sélectionnées',
                multipleSelection: 'Sélection multiple possible',
                closeDropdown: 'Ok'
            },
            nl: {
                nothingSelected: 'Selecteer alstublieft',
                searchPlaceholder: 'Zoeken...',
                noSearchResult: 'Geen resultaten voor deze zoekopdracht',
                itemsSelected: '{count} opties geselecteerd',
                multipleSelection: 'Meerdere selectie mogelijk',
                closeDropdown: 'Ok'
            },
			it: {
				nothingSelected: 'Seleziona',
				searchPlaceholder: 'Cerca...',
				noSearchResult: 'Nessun risultato per questa ricerca',
				itemsSelected: '{count} opzioni selezionate',
				multipleSelection: 'Selezione multipla possibile',
				closeDropdown: 'Ok'
			}
        };
        this.defaultConfig = {
            hideDisabled: false,
            search: false,
            multipleCount: false,
            maxSize: 10,
            checkedIcon: '\u2713'
        };
        this.config = {
            ...this.defaultConfig,
            ...config
        };
        this.locale = (config === null || config === void 0 ? void 0 : config.locale) || ((_a = document.getElementsByTagName('html')[0].lang) === null || _a === void 0 ? void 0 : _a.trim().split(/-|_/)[0]) || this.getBrowserLocale() || 'de';
        if (this.defaultTranslations[this.locale] === undefined) {
            console.warn(`"${this.locale}" is not a supported locale`);
            this.locale = 'en';
        }
        this.select = el;
        (_b = this.select.parentElement) === null || _b === void 0 ? void 0 : _b.classList.add('position-relative');
        if (!(this.select instanceof HTMLSelectElement)) {
            console.warn('BootstrapSelect used on non Select Element');
            return;
        }
        const btn = document.createElement('button');
        btn.classList.add('dropdown-item');
        btn.textContent = '\u00a0';
        document.body.append(btn);
        this.dropdownItemHeight = btn.clientHeight;
        document.body.removeChild(btn);
        // row
        let buttonRow = document.createElement('div');
        buttonRow.classList.add('row', 'gx-0');
        // init visible text
        this.textContentWrapper = document.createElement('div');
        this.textContentWrapper.classList.add('text-truncate', 'text-start');
        this.setCurrentTextContent();
        buttonRow.append(this.textContentWrapper);
        // init button
        this.button = document.createElement('button');
        this.button.type = 'button';
        // clone classList
        this.button.className = this.select.className;
        // compatible: form-select classes wont work well
        // this.button.classList.replace('form-select', 'form-control')
        // this.button.classList.replace('form-select-sm', 'form-control-sm')
        // this.button.classList.replace('form-select-lg', 'form-control-lg')
        this.button.append(buttonRow);
        this.select.classList.add('bss-select');
        // init container
        this.dropdownWrapper = document.createElement('div');
        this.dropdownWrapper.classList.add('bss');
        this.dropdownWrapper.append(this.button);
        this.select.insertAdjacentElement('afterend', this.dropdownWrapper);
        if (!this.config.mobile) {
            this.button.dataset.bsToggle = 'dropdown';
            this.button.dataset.bsAutoClose = 'outside';
            this.dropdownWrapper.classList.add('dropdown');
            this.createDropdown();
        }
        else {
            this.select.classList.add('mobile-device');
            if (this.config.hideDisabled) {
                this.select.classList.add('hide-disabled');
            }
            this.select.addEventListener('change', this.changeNative.bind(this), false);
            this.button.addEventListener('pointerdown', this.triggerNative.bind(this), false);
        }
    }
    changeNative(event) {
        this.setCurrentTextContent();
    }
    triggerNative(event) {
        this.select.dispatchEvent(new Event('focus', { bubbles: true }));
    }
    refresh(rebuild = false) {
        var _a, _b;
        if (rebuild === true) {
            this.createDropdown();
        }
        else {
            (_a = this.optionDropdownPairs) === null || _a === void 0 ? void 0 : _a.forEach((grp) => {
                if (grp.type === 'option') {
                    grp.item.classList.toggle('disabled', grp.element.disabled);
                    grp.item.classList.toggle('d-none', this.config.hideDisabled && grp.element.disabled);
                    grp.item.classList.toggle('selected', !grp.element.disabled && grp.element.selected);
                }
                else {
                    grp.options.forEach((val) => {
                        val.item.classList.toggle('disabled', val.element.disabled);
                        val.item.classList.toggle('d-none', this.config.hideDisabled && val.element.disabled);
                        val.item.classList.toggle('selected', !val.element.disabled && val.element.selected);
                    });
                }
            });
            if (this.config.hideDisabled) {
                (_b = this.optionDropdownPairs) === null || _b === void 0 ? void 0 : _b.filter((val) => val.type === 'optgroup').forEach((grp) => {
                    grp.item.classList.toggle('d-none', grp.options.filter((i) => !i.element.disabled).length > 0);
                });
            }
            this.setCurrentTextContent();
        }
    }
    setCurrentTextContent() {
        this.textContentWrapper.textContent = this.getTextContent();
    }
    getTextContent() {
        var _a;
        if (this.select.multiple) {
            const selected = Array.from(this.select.options).filter(option => option.selected && !option.disabled).map(option => option.textContent || '\u00a0');
            if (selected.length === 0) {
                return this.trans().nothingSelected;
            }
            switch (typeof this.config.multipleCount) {
                case 'boolean':
                    if (this.config.multipleCount && selected.length > 1) {
                        return this.trans().itemsSelected.replace('{count}', selected.length.toString());
                    }
                    return selected.join(', ');
                case 'function':
                    if (selected.length === 1) {
                        return selected[0];
                    }
                    return this.config.multipleCount.apply(null, [selected.length, this.locale]);
            }
        }
        else {
            return ((_a = Array.from(this.select.options).find(option => option.selected)) === null || _a === void 0 ? void 0 : _a.textContent) || this.trans().nothingSelected;
        }
    }
    trans() {
        return this.defaultTranslations[this.locale];
    }
    createDropdown() {
        var _a;
        if (this.config.mobile) {
            return;
        }
        // console.time('duration');
        (_a = this.dropdownMenu) === null || _a === void 0 ? void 0 : _a.remove();
        this.dropdownMenu = document.createElement('div');
        this.dropdownMenu.classList.add('dropdown-menu');
        this.dropdownScrollContainer = document.createElement('div');
        this.dropdownScrollContainer.classList.add('overflow-auto');
        if (this.select.multiple) {
            const multipleInfo = document.createElement('div');
            multipleInfo.classList.add('row', 'g-0', 'mb-1');
            const text = document.createElement('div');
            text.textContent = this.trans().multipleSelection;
            text.classList.add('col', 'px-2', 'text-muted');
            const close = document.createElement('button');
            close.type = 'button';
            close.classList.add('btn', 'btn-success', 'btn-sm');
            close.textContent = this.trans().closeDropdown;
            close.addEventListener('pointerdown', e => {
                var _a;
                (_a = this.getDropdown()) === null || _a === void 0 ? void 0 : _a.hide();
            });
            const col = document.createElement('div');
            col.classList.add('col-auto', 'px-1');
            col.append(close);
            multipleInfo.append(text, col);
            this.dropdownMenu.append(multipleInfo);
        }
        if (this.config.search) {
            // search
            const search = document.createElement('input');
            search.type = 'search';
            search.classList.add('form-control');
            search.placeholder = this.trans().searchPlaceholder;
            if (this.button.classList.contains('form-control-sm')) {
                search.classList.add('form-control-sm');
            }
            else if (this.button.classList.contains('form-control-lg')) {
                search.classList.add('form-control-lg');
            }
            search.addEventListener('search', this.querySearch.bind(this), false);
            search.addEventListener('keyup', this.querySearch.bind(this), false);
            const searchContainer = document.createElement('div');
            searchContainer.classList.add('mx-1', 'mb-1');
            searchContainer.append(search);
            this.dropdownMenu.append(searchContainer);
            this.noSearchResult = document.createElement('div');
            this.noSearchResult.textContent = this.trans().noSearchResult;
            this.noSearchResult.classList.add('d-none', 'text-muted', 'mx-1', 'mt-1');
            this.button.addEventListener('shown.bs.dropdown', (event) => {
                search.focus();
            });
        }
        const items = this.select.children.length - 1;
        const elements = Array.from(this.select.children, (element, k) => {
            if (element instanceof HTMLOptionElement) {
                return this.createOption(element);
            }
            return this.createOptGroup(element, k === items);
        });
        const maxHeight = this.dropdownItemHeight * this.config.maxSize;
        this.dropdownScrollContainer.style.maxHeight = maxHeight + 'px';
        this.dropdownScrollContainer.append(...elements);
        this.dropdownMenu.append(this.dropdownScrollContainer);
        this.button.insertAdjacentElement('afterend', this.dropdownMenu);
        if (this.config.search) {
            this.dropdownMenu.append(this.noSearchResult);
        }
        this.getDropdown();
        // console.timeEnd('duration')
    }
    querySearch(event) {
        const input = event.target;
        this.optionDropdownPairs.forEach((pair) => {
            var _a;
            if (pair.type === 'option') {
                if (input.value) {
                    if ((_a = pair.item.textContent) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase().includes(input.value.toLowerCase())) {
                        if (this.config.hideDisabled === false || pair.element.disabled === false) {
                            pair.item.classList.remove('d-none');
                        }
                    }
                    else {
                        pair.item.classList.add('d-none');
                    }
                }
                else if (this.config.hideDisabled === false || pair.element.disabled === false) {
                    pair.item.classList.remove('d-none');
                }
            }
            else {
                pair.options.forEach((val) => {
                    var _a;
                    if (input.value) {
                        if ((_a = val.item.textContent) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase().includes(input.value.toLowerCase())) {
                            if (this.config.hideDisabled === false || val.element.disabled === false) {
                                val.item.classList.remove('d-none');
                            }
                        }
                        else {
                            val.item.classList.add('d-none');
                        }
                    }
                    else if (this.config.hideDisabled === false || val.element.disabled === false) {
                        val.item.classList.remove('d-none');
                    }
                });
            }
        });
        let itemsVisible = this.optionDropdownPairs.filter((i) => i.type == 'option' && !i.item.classList.contains('d-none')).length;
        // hide optgroup without visible items
        this.optionDropdownPairs.filter((i) => i.type === 'optgroup').forEach((i) => {
            if (i.options.filter((p) => !p.item.classList.contains('d-none')).length === 0) {
                i.item.classList.add('d-none');
            }
            else {
                i.item.classList.remove('d-none');
                itemsVisible++;
            }
        });
        if (0 === itemsVisible) {
            this.noSearchResult.classList.remove('d-none');
        }
        else {
            this.noSearchResult.classList.add('d-none');
        }
    }
    getBrowserLocale() {
        const browserLocales = navigator.languages === undefined ? [navigator.language] : navigator.languages;
        return !browserLocales ? undefined : browserLocales[0].trim().split(/-|_/)[0];
    }
    createOption(element, optgroup) {
        const item = document.createElement('button');
        item.type = 'button';
        item.classList.add('dropdown-item', 'user-select-none', 'd-flex', 'gx-0', 'text-wrap');
        const subItem = document.createElement('div');
        subItem.classList.add('col');
        subItem.textContent = (element.dataset.text || element.textContent || '\u00a0');
        const iconSelected = document.createElement('div');
        iconSelected.classList.add('col-auto');
        iconSelected.textContent = this.config.checkedIcon;
        item.append(subItem, iconSelected);
        if (element.disabled) {
            item.classList.add('disabled');
            if (this.config.hideDisabled) {
                item.classList.add('d-none');
            }
        }
        else {
            item.addEventListener('click', e => {
                var _a, _b;
                if (this.select.multiple) {
                    element.selected = !element.selected;
                    item.classList.toggle('selected');
                }
                else {
                    element.selected = true;
                    (_a = this.dropdownMenu.querySelector('.dropdown-item.selected')) === null || _a === void 0 ? void 0 : _a.classList.remove('selected');
                    (_b = this.getDropdown()) === null || _b === void 0 ? void 0 : _b.hide();
                    item.classList.add('selected');
                }
                this.select.dispatchEvent(new Event('change'));
                this.setCurrentTextContent();
            });
            if (element.selected) {
                item.classList.add('selected');
            }
        }
        if (optgroup) {
            optgroup.options.push({
                element: element,
                item: item
            });
        }
        else {
            this.optionDropdownPairs.push({
                element: element,
                item: item,
                type: 'option'
            });
        }
        return item;
    }
    createOptGroup(element, last) {
        const container = document.createElement('div');
        container.classList.add('bss-optgroup', 'user-select-none');
        if (element.label) {
            const header = document.createElement('p');
            header.classList.add('dropdown-header');
            header.textContent = element.label || '\u00a0';
            container.append(header);
        }
        let grp = {
            element: element,
            item: container,
            type: 'optgroup',
            options: []
        };
        const elements = Array.from(element.children, (option) => this.createOption(option, grp));
        this.optionDropdownPairs.push(grp);
        // hide container if hideDisabled and all are disabled
        if (this.config.hideDisabled === true) {
            const notDisabled = Array.from(element.children).filter((el) => !el.disabled).length;
            if (notDisabled === 0) {
                container.classList.add('d-none');
            }
        }
        if (last === false) {
            const divider = document.createElement('hr');
            divider.classList.add('dropdown-divider');
            elements.push(divider);
        }
        container.append(...elements);
        return container;
    }
    getDropdown() {
        return Dropdown.getOrCreateInstance(this.button);
    }
}

export default BootstrapSelect = BootstrapSelect